import { Component, inject, OnInit } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule } from '@angular/forms';
import { AdminApiService } from '../admin-api.service';
import { LoginAttempt, PagedResult } from '../models';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { TagModule } from 'primeng/tag';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  standalone: true,
  selector: 'app-login-attempts-page',
  imports: [
    CommonModule,
    TranslateModule,
    TableModule,
    ButtonModule,
    CalendarModule,
    DropdownModule,
    InputTextModule,
    FormsModule,
    ToastModule,
    TagModule,
    DatePipe,
  ],
  providers: [MessageService],
  styleUrls: ['./login-attempts.page.scss'],
  templateUrl: './login-attempts.page.html',
})
export class LoginAttemptsPage implements OnInit {
  api = inject(AdminApiService);
  ms = inject(MessageService);

  rows: LoginAttempt[] = [];
  filter: any = { user: '', succeeded: '', from: null, to: null };
  
  // Pagination
  pagination = {
    page: 1,
    pageSize: 100,
    total: 0,
    first: 0,
  };
  
  loading = false;

  ngOnInit() {
    this.load();
  }

  load() {
    this.loading = true;
    const q: any = {
      page: this.pagination.page,
      pageSize: this.pagination.pageSize,
    };
    if (this.filter.user) q.user = this.filter.user;
    if (this.filter.succeeded !== '') q.succeeded = this.filter.succeeded === 'true';
    if (this.filter.from) q.from = this.filter.from.toISOString();
    if (this.filter.to) q.to = this.filter.to.toISOString();

    this.api.listLoginAttempts(q).subscribe({
      next: (result: any) => {
        // Handle both array and paginated response
        if (result.items) {
          // Paginated response
          this.rows = result.items;
          this.pagination.total = result.total || 0;
        } else if (Array.isArray(result)) {
          // Array response (legacy)
          this.rows = result;
          this.pagination.total = result.length;
        } else {
          this.rows = [];
          this.pagination.total = 0;
        }
        this.loading = false;
      },
      error: (err) => {
        console.error('Error loading login attempts:', err);
        this.ms.add({
          severity: 'error',
          summary: 'خطأ',
          detail: 'فشل تحميل محاولات الدخول',
        });
        this.loading = false;
      },
    });
  }

  onPageChange(event: any) {
    this.pagination.first = event.first;
    this.pagination.pageSize = event.rows;
    this.pagination.page = Math.floor(event.first / event.rows) + 1;
    this.load();
  }

  applyFilters() {
    this.pagination.first = 0;
    this.pagination.page = 1;
    this.load();
  }

  clearFilters() {
    this.filter = { user: '', succeeded: '', from: null, to: null };
    this.applyFilters();
  }

  getResultSeverity(succeeded: boolean): string {
    return succeeded ? 'success' : 'danger';
  }

  getResultLabel(succeeded: boolean): string {
    return succeeded ? 'نجح' : 'فشل';
  }
}
